import ReactDOM        from 'react-dom'
import reportWebVitals from 'reportWebVitals'
import Web             from 'web/web'
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import usePWA from 'react-pwa-install-prompt'

const AppRenderPWA = () => {
    const { isStandalone, isInstallPromptSupported, promptInstall } = usePWA()


    const onClickInstall = async () => {
        const didInstall = await promptInstall()
        if (didInstall) {
            // User accepted PWA install
        }
    }

    const renderInstallButton = () => {
        if (isInstallPromptSupported && isStandalone)
            return (
                <button onClick={onClickInstall}>Prompt PWA Install</button>
            )
        return null
    }

    return (<div>
        <Web/>
        {renderInstallButton()}
    </div>)
}

ReactDOM.render(
        <AppRenderPWA />,
  document.getElementById('root')
)
serviceWorkerRegistration.register()
reportWebVitals()